import { styled } from '@linaria/react';

import { BREAKPOINTS } from '@/constants';

import Demo, {
  DemoToggleButtonGroupControl,
} from '@/components/Demo';

function OverflowDemoWithSubsequentContent() {
  return (
    <Demo
      initialValues={{
        overflow: 'clip',
      }}
      controlPosition="top"
      customGrid={{ gridTemplateColumns: '1fr' }}
      controls={[
        <DemoToggleButtonGroupControl
          inline
          key="overflow"
          id="overflow"
          label="Clipping"
          options={[
            {
              label: 'Supported',
              value: 'clip',
            },
            {
              label: 'Unsupported',
              value: 'visible',
            },
          ]}
        />,
      ]}
    >
      {({ overflow }) => {
        return (
          <OuterWrapper>
            <Wrapper style={{ overflowY: overflow }}>
              <Josh
                src="/images/josh/josh-happy-light.png"
                alt="A 3D representation of Josh, rendered in a playful clay style"
              />
              <Title>Hello, World!</Title>
            </Wrapper>
            <Paragraph>
              This paragraph is right after the clipped container, and
              if <code>overflow: clip</code> is not supported, the
              clipped image will sit in front of this text, making it
              much more difficult to read.
            </Paragraph>
          </OuterWrapper>
        );
      }}
    </Demo>
  );
}

const OuterWrapper = styled.div`
  width: 100%;
`;

const Wrapper = styled.div`
  position: relative;
  height: 200px;
  background: hsl(220deg 100% 80%);
  border-radius: 16px;
`;

const Josh = styled.img`
  position: absolute;
  bottom: 0;
  left: 32px;
  width: 137.5px;
  height: 232px;
  transform: translateY(40%);
`;

const Title = styled.p`
  position: absolute;
  right: 2rem;
  bottom: 1.25rem;
  font-size: 3rem;
  font-weight: var(--font-weight-medium);
  text-shadow:
    0px 0px 1px hsl(220deg 100% 80%),
    0px 0px 2px hsl(220deg 100% 80%),
    0px 0px 4px hsl(220deg 100% 80%);

  @media ${BREAKPOINTS.smAndSmaller} {
    font-size: 2rem;
    right: 1.5rem;
    bottom: 1rem;
  }
`;

const Paragraph = styled.p`
  margin-top: 1rem;
  text-align: left;

  code {
    font-size: 0.9375em;
  }
`;

export default OverflowDemoWithSubsequentContent;
